import { Select, Spin } from "antd";
import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { useUserPermissions } from "../../../UserPermissionsContext";

const BranchClassWiseSales = () => {
  const { userPermissions, webApi, userData } = useUserPermissions();
  const [selectedCurrentYearBranch, setSelectedCurrentYearBranch] = useState< number | null>(null);
  const [branchDropDropwn, setBranchDropDown] = useState<any[]>([]);
  const [currrentYearBranchClassWise, setCurrentYearBranchClassWise] = useState<any>(null);
  const [currentYearBranchTableLoading, setCurrentYearBranchTableLoading] = useState(false);

  const jwtToken = Cookies.get("authToken");
  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const fetchSctsBranches = async () => {
    try {
      const response = await fetch(
        `${webApi}/sed/get_scts_branhces_dropdown_for_sed_dashboard/`,
        options,
      );

      if (!response.ok) throw new Error("Failed to fetch branches");
      const data = await response.json();
      setBranchDropDown(data.results);
    } catch (error) {
      console.error("Error fetching branches:", error);
    }
  };

  const fetchCurrentYearBranchClassWise = async () => {
    try {
      setCurrentYearBranchTableLoading(true);
      let apiUrl = `${webApi}sed/get_scts_classwise_sales_report/?branch_id=`;

      if (selectedCurrentYearBranch !== null) {
        apiUrl += selectedCurrentYearBranch;
      }

      const response = await fetch(apiUrl, options);
      if (!response.ok) throw new Error("Failed to fetch");

      const data = await response.json();
      setSelectedCurrentYearBranch(data?.results?.branch_id);
      setCurrentYearBranchClassWise(data.results); // ✅ single object
    } catch (error) {
      console.error("Fetch error:", error);
      setCurrentYearBranchClassWise(null);
    } finally {
      setCurrentYearBranchTableLoading(false);
    }
  };

  useEffect(() => {
    fetchSctsBranches();
  }, []);

  useEffect(() => {
    fetchCurrentYearBranchClassWise();
  }, [selectedCurrentYearBranch]);

  return (
    <div>
      <div className="col-xxl-12 col-xl-12 d-flex">
        {currentYearBranchTableLoading ? (
          <div
            style={{
              height: "100%",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Spin />
          </div>
        ) : (
          <div
            className="card flex-fill"
            style={{ height: "100%" }}
          >
            {/* ---------- HEADER ---------- */}
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="card-title mb-3">{"SCTS Branch Wise Sales"}</h4>

              <div className="d-flex align-items-center">
                <div className="me-3 mb-3">
                  <Select
                    showSearch
                    placeholder="Select Rank Group"
                    value={selectedCurrentYearBranch}
                    onChange={(value) => setSelectedCurrentYearBranch(value)}
                    style={{ width: 150 }}
                    optionFilterProp="label"
                    options={branchDropDropwn?.map((group: any) => ({
                      value: group.branch_id,
                      label: group.name,
                    }))}
                    filterOption={(input, option) =>
                      String(option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  />
                </div>
              </div>
            </div>

            {/* ---------- BODY (SCROLLABLE) ---------- */}
            <div className="card-body">
              <ul className="list-group">
                {currrentYearBranchClassWise?.class_wise_sales?.map(
                  (item: any, index: any) => {
                    const percentage =
                      item.strength > 0
                        ? Math.min(
                            (item.total_sales / item.strength) * 100,
                            100,
                          )
                        : 0;

                    const barColor =
                      percentage >= 75
                        ? "bg-success"
                        : percentage >= 50
                          ? "bg-info"
                          : percentage >= 25
                            ? "bg-warning"
                            : "bg-danger";
                    return (
                      <li className="list-group-item" key={item.class_id}>
                        <div className="row align-items-center">
                          <div className="col-sm-4">
                            <p className="text-dark mb-0">
                              {item.class_name}
                              <small className="text-muted">
                                {" "}
                                ({item.total_sales} / {item.strength})
                              </small>
                            </p>
                          </div>

                          <div className="col-sm-8 d-flex align-items-center gap-2">
                            <div
                              className="progress flex-grow-1"
                              style={{ height: "8px" }}
                            >
                              <div
                                className={`progress-bar ${barColor} rounded`}
                                role="progressbar"
                                style={{ width: `${percentage}%` }}
                                aria-valuenow={percentage}
                                aria-valuemin={0}
                                aria-valuemax={100}
                              />
                            </div>

                            {/* Percentage text */}
                            <span className="small fw-bold text-dark">
                              {percentage.toFixed(0)}%
                            </span>
                          </div>
                        </div>
                      </li>
                    );
                  },
                )}
              </ul>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BranchClassWiseSales;
